export const STORE_USER = 'STORE_USER';
export const REMOVE_USER = 'REMOVE_USER';
export const LOAD_COMUNICADOR = 'LOAD_COMUNICADOR';